module.exports = __webpack_public_path__ + "img/8-text.0e80fa5d.png";